import { computed } from 'vue'
import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import { rouletteApi } from '@/api'
// RouletteConfigRead type used implicitly
import { POLLING_INTERVALS, STALE_TIME, RETRY_CONFIG } from '@/config/query'

export function useRouletteConfig() {
  const { data, error, isFetching, refetch } = useQuery({
    queryKey: ['roulette', 'config'],
    queryFn: async () => {
      const response = await rouletteApi.getConfig()
      if (response.success && response.data) {
        return response.data
      }
      throw new Error(response.error ?? 'Failed to fetch roulette config')
    },
    refetchInterval: POLLING_INTERVALS.BACKEND_API,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    placeholderData: keepPreviousData,
    retry: RETRY_CONFIG.ATTEMPTS,
    staleTime: STALE_TIME.MEDIUM,
  })

  return {
    config: computed(() => data.value),
    nextRefreshTime: computed(() =>
      data.value ? new Date(data.value.spin_refresh_datetime) : null
    ),
    lastSnapshotAt: computed(() =>
      data.value?.last_holders_snapshot_at ? new Date(data.value.last_holders_snapshot_at) : null
    ),
    isLoading: computed(() => isFetching.value && !data.value),
    hasError: computed(() => Boolean(error.value)),
    errorMessage: computed(() => error.value?.message ?? 'Failed to load config'),
    refetch,
  }
}
